module.exports = __webpack_public_path__ + "img/qna.61c44c3b.svg";